import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../http";
import type { Chat } from "@/lib/types/secure-llm";

interface ChatsResponse {
  count: number;
  items: Array<Chat>;
  next_page: string | null;
  previous_page: string | null;
}

async function getMyChats() {
  return await api.governance.get<ChatsResponse>("my-chats");
}

export const myChatsQueryOptions = queryOptions({
  queryKey: ["secure-llm", "my-chats"],
  async queryFn() {
    const res = await getMyChats();
    const data = await res.json();
    return data;
  },
});

export function useMyChats() {
  return useQuery(myChatsQueryOptions);
}
